import { useMemo } from 'react';

import findLast from 'lodash/findLast';

import { CancellationPolicyType } from '@nocowanie/core/enums';

import { apiTypes } from '@app/models';

export const calculatePolicyInfo = (
    cancellationRules: apiTypes.Maybe<apiTypes.CancellationRules> | undefined,
) => {
    if (!cancellationRules?.rules?.length) {
        return {
            policyType: CancellationPolicyType.NoRefund,
        };
    }

    if (cancellationRules.freeCancellation) {
        const lastRuleWithFullRefund = findLast(
            cancellationRules.rules || [],
            rule => rule?.prepaidPercentage === 0,
        );

        return {
            policyType: CancellationPolicyType.FullRefund,
            policyDate: lastRuleWithFullRefund?.to,
        };
    }

    const lastRuleWithPartialRefund = findLast(
        cancellationRules.rules || [],
        rule => rule && rule?.prepaidPercentage > 0 && rule?.prepaidPercentage < 100,
    );

    if (lastRuleWithPartialRefund) {
        return {
            policyType: CancellationPolicyType.PartialRefund,
            policyDate: cancellationRules.prepaidTo,
            policyPenalty: cancellationRules.prepaidRate,
        };
    }

    return {
        policyType: CancellationPolicyType.NoRefund,
    };
};

export const usePolicyInfo = (
    cancellationRules: apiTypes.Maybe<apiTypes.CancellationRules> | undefined,
) => {
    return useMemo(() => calculatePolicyInfo(cancellationRules), [cancellationRules]);
};
